export default{
    apiKey: "AIzaSyCj3NWCb3pxlnFFz6SXoKXTzteuiB8Yw8o",
    authDomain: "newclass-b2b32.firebaseapp.com",
    databaseURL: "https://newclass-b2b32.firebaseio.com",
    projectId: "newclass-b2b32",
    storageBucket: "newclass-b2b32.appspot.com",
    messagingSenderId: "695766713688",
    appId: "1:695766713688:web:5b2218a83dc447f4ccd12d",
    measurementId: "G-9SZV2JGPB2"
}